import React from 'react';
import { Pagination } from '../../../_lib/components/Pagination';
import ResultListSettings from '../../../components/molecules/ResultListSettings/ResultListSettings';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { FACETS } from '../../../components/molecules/ResultListSettings/ResultListSettings.enums';
import { murmurhash } from '../../../lib/js/hash';
import { Tile } from '../../../_lib/components/Tiles';
import { TileContainerModifier } from '../../../_lib/components/Tiles/Tile';
import { TileGrid, TileGridModifier } from '../../../_lib/components/Tiles/TileGrid';
import { EventListSearchResults } from '../EventListDetails.types';
import { EventListTileItem } from './EventListTileItem';

type EventListTilesProps = {
  searchResults: EventListSearchResults;
};

export function EventListTiles({ searchResults }: EventListTilesProps) {
  const { t } = useSonTranslation('EventList');
  const { eventStartDate: filter, ...facetsWithoutEventStartDate } = searchResults.facets ?? {};

  return (
    <div className="event-list-tiles">
      <ResultListSettings
        key={murmurhash(searchResults)}
        sort={searchResults.sort}
        facets={facetsWithoutEventStartDate}
        filter={filter}
        wantedFacets={[FACETS.FQ_PAGE_CATEGORY_TITLES]}
        resetAllFiltersUrl={searchResults.resetAllFiltersUrl}
      />
      {searchResults.events && searchResults.events.length > 0 && (
        <>
          <h2 className="invisible">{t('headline')}</h2>
          <TileGrid modifier={[TileGridModifier.FOUR_COLUMNS_MAX, TileGridModifier.ROW_GAP_LARGE]}>
            {searchResults.events.map(event => (
              <Tile key={murmurhash(event)} modifier={TileContainerModifier.IMAGE_TOP}>
                <EventListTileItem event={event} />
              </Tile>
            ))}
          </TileGrid>
          <Pagination pageItems={searchResults.pageItems} />
        </>
      )}
    </div>
  );
}
